import { memo } from "react";
import { useTranslation } from "react-i18next";
import Button from "../Buttons/Button";
import { ButtonColors } from "../Buttons/buttons.types";
import DescriptionText from "../Text/DescriptionText";

type ErrorFallbackProps = {
  error?: unknown;
  btnTitle?: string;
  onReload?: () => void;
  buttonColor?: ButtonColors;
};

function ErrorFallback({
  error,
  btnTitle,
  onReload,
  buttonColor = ButtonColors.Gray,
}: ErrorFallbackProps) {
  const { t } = useTranslation("common");
  const errorMessage =
    error instanceof Error
      ? error.message
      : typeof error === "string"
        ? error
        : t("errorDefault");
  const buttonTitle = btnTitle || t("tryAgain");

  return (
    <div className={"flex flex-1 centered gap-10"}>
      <DescriptionText>{errorMessage}</DescriptionText>
      {onReload && (
        <Button
          title={buttonTitle}
          color={buttonColor}
          onClick={onReload}
          dataTestid={"reload-button"}
        />
      )}
    </div>
  );
}

export default memo(ErrorFallback);
